import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-launcher-admin',
  templateUrl: './chat-launcher-admin.component.html',
  styleUrls: ['./chat-launcher-admin.component.css']
})
export class ChatLauncherAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
